/**
 * Frontier model registry — the single source of truth for the 6 top LLMs
 * we surface across the site (hero strip, header picker, Wikifi workspace).
 *
 * `wikifiId` is the CANONICAL backend model id (see WIKIFI_MODEL_ROSTER in
 * server.py). It's what the workspace sends as the `mode` field on
 * /api/jobs/wikifi, so it MUST exactly match one of the backend's accepted
 * ids or the API returns `400: Unknown model '<id>'`.
 *
 * Each `logos` entry is an ordered fallback chain so we always render a real
 * brand mark instead of a generic letter placeholder:
 *   1. SimpleIcons CDN — hand-curated brand SVG in the vendor's color.
 *   2. Clearbit — rasterized company logo pulled from the domain.
 * The component consuming this steps through the chain and finally falls
 * back to a colored letter disc if every URL 404s.
 */
export const FRONTIER_MODELS = [
  {
    id: "gpt", wikifiId: "openai/gpt-5.4", name: "GPT", vendor: "OpenAI", dot: "#10A37F",
    logos: [
      "https://cdn.simpleicons.org/openai/10A37F",
      "https://logo.clearbit.com/openai.com",
    ],
  },
  {
    id: "claude", wikifiId: "anthropic/claude-sonnet-4-5-20250929", name: "Claude", vendor: "Anthropic", dot: "#D97757",
    logos: [
      "https://cdn.simpleicons.org/anthropic/D97757",
      "https://logo.clearbit.com/anthropic.com",
    ],
  },
  {
    id: "gemini", wikifiId: "gemini/gemini-3-flash-preview", name: "Gemini", vendor: "Google", dot: "#4285F4",
    logos: [
      "https://cdn.simpleicons.org/googlegemini/4285F4",
      "https://logo.clearbit.com/gemini.google.com",
    ],
  },
  {
    id: "grok", wikifiId: "xai/grok-4.5", name: "Grok", vendor: "xAI", dot: "#0B1220",
    logos: [
      "https://cdn.simpleicons.org/x/0B1220",
      "https://logo.clearbit.com/x.ai",
    ],
  },
  {
    id: "perplexity", wikifiId: "perplexity/sonar", name: "Perplexity", vendor: "Perplexity", dot: "#20B8A6",
    logos: [
      "https://cdn.simpleicons.org/perplexity/20B8A6",
      "https://logo.clearbit.com/perplexity.ai",
    ],
  },
];

export const DEFAULT_MODEL_ID = "gpt";

export function findModel(id) {
  return FRONTIER_MODELS.find((m) => m.id === id) || FRONTIER_MODELS[0];
}
